import { render } from "./MenuBar.vue?vue&type=template&id=10a3921e"
import script from "./MenuBar.vue?vue&type=script&lang=js"
export * from "./MenuBar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Accent\\Vue_Projects\\NEWWEBECOM_OCT6_2026\\Accent-MIO\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__